import { Field, Input, mergeClasses } from "@fluentui/react-components";
import { useFormContext, get, Controller, FieldValues } from "react-hook-form";
import { useFormTextFieldStyle } from "./style";
import { useIntl } from "react-intl";
import { useMemo } from "react";
import { FormFieldProps } from ".";

export const FormTextField = <TFormValues extends FieldValues>(
	props: FormFieldProps
) => {
	const {
		formState: { errors },
	} = useFormContext<TFormValues>();

	const classes = useFormTextFieldStyle();
	const intl = useIntl();

	const error = get(errors, props.propertyName);
	const errorToDisplay =
		(error && error.type !== "validate") || !props.hideCustomValidationError
			? error
			: undefined;

	const invalidInputMessage = useMemo(() => {
		return intl.formatMessage({
			id: "Common.Validations.InvalidInput",
		});
	}, [props.pattern]);

	const patternRule = props.pattern
		? { value: props.pattern, message: invalidInputMessage }
		: undefined;

	const maxLengthMessage = useMemo(() => {
		return intl.formatMessage(
			{ id: "Common.Validations.MaxLength" },
			{ maxLength: props.maxLength }
		);
	}, [props.maxLength]);

	const maxLengthRule = props.maxLength
		? { value: props.maxLength, message: maxLengthMessage }
		: undefined;

	return (
		<Controller
			name={props.propertyName}
			defaultValue=""
			rules={{
				...props.validationRules,
				pattern: patternRule,
				maxLength: maxLengthRule,
			}}
			render={({ field: { onChange, onBlur, value } }) => (
				<Field
					label={intl.formatMessage({
						id: props.translationKey,
					})}
					validationState={errorToDisplay ? "error" : "none"}
					validationMessage={errorToDisplay?.message}
					className={mergeClasses(
						classes.field,
						!errorToDisplay && classes.fieldNoError
					)}
					required={!!props.validationRules?.required}
					onChange={(value) => {
						onChange(value);
						if (props.afterChange) {
							props.afterChange();
						}
					}}
					onBlur={onBlur}
				>
					<Input
						autoComplete="off"
						type="text"
						appearance="filled-lighter"
						value={value}
						className={mergeClasses(
							classes.inputField,
							props.classesNames?.inputField
						)}
					/>
				</Field>
			)}
		></Controller>
	);
};
